var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHardwoodFloor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.9431 33.6704C35.8684 33.6261 35.7973 33.576 35.7304 33.5206L25.5816 23.3718C25.5253 23.315 25.4721 23.2553 25.4221 23.193L29.5106 19.1044C29.5698 19.214 29.6394 19.3176 29.7185 19.4137L35.6628 25.358C35.7498 25.445 35.8464 25.5224 35.9382 25.6045L35.9431 33.6704Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.46167 35.1735C2.50769 35.0987 2.55939 35.0276 2.61632 34.9608L12.7652 24.812C12.828 24.7492 12.8956 24.696 12.9391 24.6573L17.0277 28.7459C16.9186 28.8053 16.8165 28.8766 16.7232 28.9585C14.7353 30.9335 12.7539 32.9133 10.7789 34.898C10.6919 34.985 10.6146 35.0816 10.5276 35.1735H2.46167Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9431 22.7338L31.1587 17.9735C31.0668 17.8866 30.9605 17.8141 30.8494 17.7271C30.9364 17.6208 30.9847 17.5628 31.0378 17.5096L35.8126 12.73C35.8513 12.6913 35.8996 12.6575 35.9431 12.6188V22.7338Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3933 35.1734L18.0618 30.4808C18.1826 30.3648 18.2841 30.2247 18.4049 30.0845C18.5064 30.1667 18.5692 30.215 18.6224 30.2682L23.3972 35.043C23.4407 35.0865 23.4697 35.13 23.5083 35.1734H13.3933Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M35.943 9.75304L34.9764 10.6858L30.8831 6.6069C30.9765 6.55547 31.0641 6.49388 31.144 6.42325L35.6578 1.91427C35.7486 1.83488 35.8438 1.76065 35.943 1.69196V9.75304Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3742 35.1734L25.4463 34.2069L29.4768 30.1715C29.5107 30.2005 29.588 30.2682 29.6605 30.3406L34.242 34.9221C34.3133 35.0049 34.3795 35.0921 34.4401 35.1831L26.3742 35.1734Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4436 16.171L8.98584 6.70841L12.939 2.75037L22.3968 12.2081L18.4436 16.171Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9854 17.6353L29.3851 8.22589C30.7141 9.5549 32.0576 10.8936 33.377 12.2178L23.9724 21.6272L19.9854 17.6353Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M7.45869 27.1268L3.51514 23.1785C6.64678 20.042 9.79776 16.8959 12.9536 13.7401L16.9019 17.6836L7.45869 27.1268Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9239 32.6508L14.4758 23.1978L18.4435 19.2205L27.8916 28.6734L23.9239 32.6508Z",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9143 10.6664L19.9272 6.67454L20.1206 6.47156C22.1503 4.44179 24.1801 2.41364 26.2099 0.387095C26.3158 0.27895 26.4557 0.210671 26.6061 0.193787C29.1579 0.193787 31.7096 0.193787 34.2564 0.193787H34.3869C30.8944 3.68305 27.4036 7.17392 23.9143 10.6664Z",
    fill: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4312 12.2177L7.44899 16.1999L7.25084 16.0115C5.22108 13.9817 3.19292 11.9519 1.16638 9.92215C1.05208 9.80635 0.98197 9.65417 0.968234 9.49204C0.968234 6.9645 0.968234 4.43212 0.968234 1.90458C0.96469 1.85309 0.96469 1.80143 0.968234 1.74994L11.4312 12.2177Z",
    fill: "black"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M0.978027 22.613V12.7155L5.9268 17.6643L0.978027 22.613Z",
    fill: "black"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M7.43446 5.15707L2.49536 0.213135H12.3542L7.43446 5.15707Z",
    fill: "black"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4407 0.203456L18.4436 5.18121L14.4082 1.14585C14.6933 0.870385 15.0123 0.556251 15.3458 0.251786C15.4195 0.201586 15.5081 0.177739 15.5971 0.18412H23.3295C23.3675 0.182684 23.4054 0.189275 23.4407 0.203456Z",
    fill: "black"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M5.94614 28.6734L0.978027 33.6415C0.978027 33.5545 0.978027 33.4626 0.978027 33.366C0.978027 30.8868 0.978027 28.4076 0.978027 25.9284C0.995132 25.7495 1.06781 25.5805 1.18585 25.4451C1.42265 25.1599 1.69812 24.9086 1.93492 24.667L5.94614 28.6734Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHardwoodFloor);
export default __webpack_public_path__ + "static/media/hardwood-floor.11a8a1fbe6a6eced4e148cf16f827ef2.svg";
export { ForwardRef as ReactComponent };